import React, {FC} from 'react'

interface ImageModalProps {
  imageUrl: string | null
  show: boolean
  onClose: () => void
  altText?: string
}

export const ImageModal: FC<ImageModalProps> = ({imageUrl, show, onClose, altText = 'Enlarged view'}) => {
  if (!show || !imageUrl) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1050, // Ensure it's above other content
      }}
      onClick={onClose} // Close on backdrop click
    >
      <div
        style={{
          position: 'relative',
          padding: '20px',
          background: 'white',
          borderRadius: '8px',
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#000', // Ensure close button is visible
          }}
        >
          &times;
        </button>
        <img
          src={imageUrl}
          alt={altText}
          style={{maxWidth: '80vw', maxHeight: '80vh', display: 'block'}}
        />
      </div>
    </div>
  )
}
